import CashTamerHttpClient from './CashTamerHttpClient';
import CashTamerApiBase from './CashTamerApiBase';
import BankAccountMemberDashboardResponseModel from '@/models/bankaccountmembers/BankAccountMemberDashboardResponseModel';

export default class BankAccountMembersApi extends CashTamerApiBase {

    public async changeRoleAsync(bankAccountId: number, bankAccountMemberId: number, roleTypeId: number, jwt: string): Promise<void> {

        try {
            const httpClient = new CashTamerHttpClient();

            const url: string = 'member/bankaccounts/' + bankAccountId + '/members/' + bankAccountMemberId + '/' + roleTypeId;
            await httpClient.securePutAsync(url, null, jwt);
        }
        catch ( err ) {
            return this.handleApiError(err);
        }
    }

    public async deleteAsync(bankAccountId: number, bankAccountMemberId: number, jwt: string): Promise<void> {

        try {
            const httpClient = new CashTamerHttpClient();

            const url: string = 'member/bankaccounts/' + bankAccountId + '/members/' + bankAccountMemberId;
            await httpClient.secureDeleteAsync(url, jwt);
        }
        catch ( err ) {
            return this.handleApiError(err);
        }
    }

    public async getBankAccountMemberDashBoardAsync(bankAccountId: number, bankAccountMemberId: number, jwt: string): Promise<BankAccountMemberDashboardResponseModel> {

        try {
            const httpClient = new CashTamerHttpClient();

            const url: string = 'member/bankaccounts/' + bankAccountId + '/members/' + bankAccountMemberId;
            const httpResponse = await httpClient.secureGetAsync(url, jwt);

            const bankAccountMember = new BankAccountMemberDashboardResponseModel();
            bankAccountMember.authorizedOperations = httpResponse.data.authorizedOperations;
            bankAccountMember.bankAccountMemberId = httpResponse.data.bankAccountMemberId;
            bankAccountMember.createdBy = httpResponse.data.createdBy;
            bankAccountMember.createdDateTimeUtc = httpResponse.data.createdDateTimeUtc;
            bankAccountMember.givenName = httpResponse.data.givenName;
            bankAccountMember.roleType = httpResponse.data.roleType;
            bankAccountMember.roleTypeId = httpResponse.data.roleTypeId;
            bankAccountMember.surname = httpResponse.data.surname;

            return bankAccountMember;
        }
        catch (err) {
            return this.handleApiError(err);
        }
    }

}
